export default {
  topNavbar: 1100 as const,
  modal: 99999 as const,
  modalCalendar: 999999 as const,
  secondModal: 1300 as const,
  checkoutPage: 9999 as const,
  contactButton: 9991 as const
};
